import {useContext, useState, useEffect} from "react";
import moment from "moment-timezone";
import "moment-timezone";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import AuthContext from "context/AuthContext";
import IconForLevel from "./IconForLevel";
import ConditionalRender from "components/ConditionalRender";
import ModalListUnloads from "./ModalListUnloads";

const UnloadTimeModel = {
    item: null,
    date: null,
    time: null,
    value: 0,
    level: 0,
    exists: false,
};

const UnloadCell = ({item, date, handleClickEdit}) => {
    const {org} = useContext(AuthContext);
    const [unload, setUnload] = useState({...UnloadTimeModel});
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setterUnload();
    }, [item]);

    const setterUnload = () => {
        const unloads = item.unloads[date.date];
        if (!Array.isArray(unloads) || unloads.length === 0) {
            setUnload({...UnloadTimeModel});
            return;
        }
        const maxUnload = unloads.reduce((max, current) => {
            if (current.level > max.level) {
                return current;
            }
            if (current.level === max.level && current.timestamp > max.timestamp) {
                return current;
            }
            return max;
        });
        setUnload(maxUnload);
    };

    const handleClickList = () => {
        const unloads = item.unloads[date.date];
        if (!unloads.length) return false;
        setShowModal(true);
    };

    const getHour = (unloadData) => {
        if (!unloadData || !unloadData.time) return "";
        const dateTimeUTC = moment.utc(`${unloadData.date}T${unloadData.time}.000Z`);
        const dateTimeTZ = dateTimeUTC.tz(org?.timezone || "Europe/Madrid");
        return dateTimeTZ.format("HH:mm");
    };

    return (
        <>
            <ConditionalRender condition={item.unloads[date.date].length && unload.time !== null}>
                <button
                    type="button"
                    className="btn btn-link p-0 m-0"
                    style={{position: "absolute", top: "2px", left: "4px"}}
                    onClick={handleClickList}>
                    <FontAwesomeIcon icon="list" className="text-dark-emphasis" />
                </button>
                <div className="row d-flex justify-content-center" data-date={date.date} onClick={handleClickEdit}>
                    <div className="col data-cell" data-time={unload.time} data-value={unload.value} data-level={unload.level}>
                        <span>{getHour(unload)}</span>
                        <br />
                        <span>{unload.value}%</span>
                    </div>
                    <div className="col data-level">
                        <IconForLevel level={unload.level} />
                    </div>
                </div>
            </ConditionalRender>
            <ConditionalRender condition={showModal}>
                <ModalListUnloads show={showModal} setShow={setShowModal} item={item} date={date} />
            </ConditionalRender>
        </>
    );
};
export default UnloadCell;
